const licensingType = {
  type: 'ConnectEd',
  key: 'licensingType',
  value: 'directLicensing'
};

export default licensingType;



// WEBPACK FOOTER //
// ./app/models/licensingTypeIntegration.js